/**
 * The map of the room the player is in. `Game` sets `window.currentMapID` when the scene starts.
 * There is no default map (SC-422): VR reads and writes need the real one.
 */
export function currentMapId(): string | null {
  if (typeof window === 'undefined') return null
  const mapId = (window as any).currentMapID
  return typeof mapId === 'string' && mapId ? mapId : null
}

export function requireCurrentMapId(): string {
  const mapId = currentMapId()
  if (!mapId) throw new Error('No map is loaded')
  return mapId
}
